import script from "./SofortVersichert.vue?vue&type=script&setup=true&lang=js"
export * from "./SofortVersichert.vue?vue&type=script&setup=true&lang=js"

import "./SofortVersichert.vue?vue&type=style&index=0&id=ae660516&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae660516"]])

export default __exports__